/* eslint-disable no-case-declarations */
import {
  BROKER_LOGIN_CLEAR_FORM,
  BROKER_LOGIN_SCREEN_UPDATE_FORM,
  BROKER_LOGIN_SET_FORM_STRUCTURE,
  BROKER_LOGIN_REQUEST,
  BROKER_LOGIN_SUCCESS,
  BROKER_LOGIN_FAILURE,
} from '../../constants/ActionTypes';

const brokerLoginScreen = (
  state = {
    loading: false,
    formData: {},
    structure: [],
    errors: {},
  },
  action
) => {
  switch (action.type) {
    case BROKER_LOGIN_CLEAR_FORM:
      return {
        loading: false,
        formData: {},
        structure: [],
        errors: {},
      };
    case BROKER_LOGIN_SET_FORM_STRUCTURE:
      return {
        ...state,
        structure: action.value,
      };
    case BROKER_LOGIN_SCREEN_UPDATE_FORM:
      const formDataUpdateForm = state.formData;

      if (!formDataUpdateForm[action.field]) {
        formDataUpdateForm[action.field] = '';
      }

      formDataUpdateForm[action.field] = action.value;

      return {
        ...state,
        formData: formDataUpdateForm,
      };
    case BROKER_LOGIN_REQUEST:
      return {
        ...state,
        errors: {},
        loading: true,
      };
    case BROKER_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case BROKER_LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.data,
      };
    default:
      return state;
  }
};

export default brokerLoginScreen;
